// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1bu0A","content":"styles_content__GNNCs"};